import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useRevealOnScroll } from "../../hook/useRevealOnScroll";

export type RevealSectionProps = Readonly<{
  children: React.ReactNode;
}>;

export default function RevealSection({ children }: RevealSectionProps) {
  const theme = useTheme();
  const { ref, isVisible } = useRevealOnScroll();

  return (
    <Box
      ref={ref}
      sx={{
        transform: isVisible ? "none" : "translateY(10px)",
        opacity: isVisible ? 1 : 0,
        transition: theme.transitions.create(["transform", "opacity"], {
          duration: theme.transitions.duration.standard,
          easing: theme.transitions.easing.easeOut,
        }),
      }}
    >
      {children}
    </Box>
  );
}
